module.exports = __webpack_public_path__ + "img/medical_physical_05.7d2fd422.jpg";